import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  to: string;
  message_type: 'text';
  payload: { body: string };
  send_at: number;
};

type MutationResponse = {
  status: number;
  data: { schedule_id: string };
};

export const useCreateScheduledMessageMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while scheduling the message',
    endpoint: '/api/admin/whatsapp/scheduled',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
